/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { FormattedMessage } from 'react-intl-next';
import Avatar from '@atlaskit/avatar';
import { cssMap, jsx } from '@atlaskit/css';
import { Inline, Stack, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { type ExternalUser } from '@atlaskit/user-picker';

import { messages } from '../i18n';

const styles = cssMap({
	description: {
		marginLeft: token('space.050', '4px'),
		color: token('color.text', '#172B4D'),
	},
	name: {
		color: token('color.text', '#172B4D'),
	},
	disabledName: {
		color: token('color.text.disabled', '#091E424F'),
	},
});

type Props = {
	isDisabled: boolean;
	member: ExternalUser;
	showSubText: boolean;
};

const TeamMember = ({ isDisabled, member, showSubText }: Props) => (
	<Inline as="span" alignBlock="center" testId="team-member">
		<Inline as="span">
			<Avatar
				src={member.avatarUrl}
				size="small"
				borderColor="transparent"
				isDisabled={isDisabled}
			/>
		</Inline>
		<Stack as="span" xcss={styles.description}>
			<span css={[styles.name, isDisabled && styles.disabledName]}>{member.name}</span>
			{showSubText && (
				<Text as="span" color="color.text.subtlest" testId={`team-member-byline-${member.id}`}>
					<FormattedMessage {...messages.inviteeListLabelThirdPartyTeamMemberByline} />
				</Text>
			)}
		</Stack>
	</Inline>
);

export default TeamMember;
